<template>
    <section id="steps-uid-6-p-0" role="tabpanel" aria-labelledby="steps-uid-6-h-0" class="body current" aria-hidden="false">
        <form @submit.prevent="validate">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="freights">Freights</label>
                        <multiselect
                                :close-on-select="true"
                                :options="freights"
                                :searchable="false"
                                :show-labels="false"
                                data-vv-as="freights"
                                id="freights"
                                name="freights"
                                class="form-control"
                                v-model="logistics.freight"
                                placeholder="Select Freight"
                                v-validate="'required'"
                                :class="{'is-invalid': submitted && errors.has('freights')}">
                            <template slot="singleLabel" slot-scope="{ option }">
                                {{ option.text }}
                            </template>
                            <template slot="option" slot-scope="props">
                                <div class="option__desc">
                                    <h5>{{ props.option.text }}</h5>
                                </div>
                            </template>
                        </multiselect>
                    </div>
                    <div class="form-group">
                        <label>Storage</label>
                        <div class="col-md-4 form-check">
                            <input type="radio"
                                   id="flatbottombin"
                                   name="flatbottombin"
                                   class="form-check-input"
                                   value="FLATBOTTOMBIN"
                                   v-model="logistics.storage"
                                   data-vv-as="storage"
                                   v-validate="'required'"
                                   :class="{'is-invalid': submitted && errors.has('flatbottombin')}"
                                   @click="setStorage">
                            <label class="form-check-label" for="flatbottombin">Flat Bottom Bin</label>
                        </div>
                        <div class=" col-md-4 form-check">
                            <input type="radio"
                                   id="hopperbin"
                                   name="hopperbin"
                                   class="form-check-input"
                                   value="HOPPERBIN"
                                   v-model="logistics.storage"
                                   data-vv-as="storage"
                                   v-validate="'required'"
                                   :class="{'is-invalid': submitted && errors.has('hopperbin')}"
                                   @click="setStorage">
                            <label class="form-check-label" for="hopperbin">Hopper Bin</label>
                        </div>
                        <div class=" col-md-4 form-check">
                            <input type="radio"
                                   id="grainbag"
                                   name="grainbag"
                                   class="form-check-input"
                                   value="GRAINBAG"
                                   v-model="logistics.storage"
                                   data-vv-as="storage"
                                   v-validate="'required'"
                                   :class="{'is-invalid': submitted && errors.has('grainbag')}"
                                   @click="setStorage">
                            <label class="form-check-label" for="grainbag">Grain Bag</label>
                        </div>
                        <div class=" col-md-4 form-check">
                            <input type="radio"
                                   id="groundpile"
                                   name="groundpile"
                                   class="form-check-input"
                                   value="GROUNDPILE"
                                   v-model="logistics.storage"
                                   data-vv-as="storage"
                                   v-validate="'required'"
                                   :class="{'is-invalid': submitted && errors.has('groundpile')}"
                                   @click="setStorage">
                            <label class="form-check-label" for="groundpile">Ground Pile</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Movement Year</label>
                        <div class="form-check" v-for="year in years" v-bind:key="year" v-on:click="setYear(year)">
                            <input type="radio"
                                   :id="year"
                                   name="movement_year"
                                   :value="year"
                                   class="form-check-input"
                                   v-model="logistics.year"
                                   data-vv-as="harvest_year"
                                   :class="{'is-invalid': submitted && errors.has('movement_year')}"
                                   v-validate="'required'">
                            <label class="form-check-label" v-on:click="setYear(year)" :for="year">
                                {{year}}
                            </label>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="period">Period</label>
                        <multiselect
                                :close-on-select="true"
                                :options="period"
                                :searchable="false"
                                :show-labels="false"
                                data-vv-as="period"
                                id="period"
                                name="period"
                                class="form-control"
                                open-direction="top"
                                v-model="logistics.period"
                                placeholder="Select Period"
                                v-validate="'required'"
                                :class="{'is-invalid': submitted && errors.has('period')}">
                            <template slot="singleLabel" slot-scope="{ option }">
                                {{option.name}}
                            </template>
                            <template slot="option" slot-scope="props">
                                <div class="option__desc">
                                    <h5>{{props.option.name}}</h5>
                                    <h6>{{props.option.description}}</h6>
                                </div>
                            </template>
                        </multiselect>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Pickup Location</label>
                        <div class="form-group row">
                            <label class="col-md-4">Address Type</label>
                            <div class="col-md-4 form-check">
                                <input type="radio"
                                       id="business"
                                       name="business"
                                       class="form-check-input"
                                       value="BUSINESS"
                                       v-model="logistics.location.type"
                                       data-vv-as="address-type"
                                       v-validate="'required'"
                                       :class="{'is-invalid': submitted && errors.has('business')}"
                                       @click="setAddressType">
                                <label class="form-check-label" for="business">Business</label>
                            </div>
                            <div class=" col-md-4 form-check">
                                <input type="radio"
                                       id="farm"
                                       name="farm"
                                       class="form-check-input"
                                       value="FARM"
                                       v-model="logistics.location.type"
                                       data-vv-as="address-type"
                                       v-validate="'required'"
                                       :class="{'is-invalid': submitted && errors.has('farm')}"
                                       @click="setAddressType">
                                <label class="form-check-label" for="farm">Farm</label>
                            </div>
                        </div>
                        <div class="form-group">
                            <input type="text"
                                   name="line1"
                                   class="form-control m-b-20"
                                   placeholder="Address Line 1"
                                   v-model="logistics.location.address.line1"
                                   data-vv-as="address-line-1"
                                   v-validate="'required'"
                                   :class="{'is-invalid': submitted && errors.has('line1')}">
                            <input type="text" class="form-control m-b-20" placeholder="Address Line 2" v-model="logistics.location.address.line2">
                            <input type="text"
                                   name="city"
                                   class="form-control m-b-20"
                                   placeholder="City"
                                   v-model="logistics.location.address.city"
                                   data-vv-as="city"
                                   v-validate="'required'"
                                   :class="{'is-invalid': submitted && errors.has('city')}">
                            <input type="text"
                                   name="state"
                                   class="form-control m-b-20"
                                   placeholder="State"
                                   v-model="logistics.location.address.state"
                                   data-vv-as="state"
                                   v-validate="'required'"
                                   :class="{'is-invalid': submitted && errors.has('state')}">

                            <multiselect
                                    id="country"
                                    name="country"
                                    class="form-control m-b-20"
                                    :class="{'is-invalid': submitted && errors.has('country')}"
                                    v-model="logistics.location.address.country"
                                    :options="countries"
                                    label="name"
                                    placeholder="Country"
                                    v-validate="'required'"
                                    data-vv-as="Country"
                                    track-by="code">
                            </multiselect>
                            <input type="text"
                                   name="postal_code"
                                   class="form-control m-b-20"
                                   placeholder="Postal Code"
                                   v-model="logistics.location.address.postal_code"
                                   data-vv-as="postal_code"
                                   v-validate="'required'"
                                   :class="{'is-invalid': submitted && errors.has('postal_code')}">
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </section>
</template>

<script>
    import Multiselect from "vue-multiselect";
    import countries from "../../../../../assets/js/countries";

    export default {
        name: "AllOffers",
        components: {Multiselect},
        data() {
            return {
                submitted: false,
                selectedCountry: this.$parent.selectedCountry,
                freights: [
                    {value: "PICKUP", text: "Pickup"},
                    {value: "DELIVER", text: "Deliver"}
                ],
                period: [
                    {name: "Q1", description: "(January, February, March)"},
                    {name: "Q2", description: "(March, April, May)"},
                    {name: "Q3", description: "(June, July, August)"},
                    {name: "Q4", description: "(September, October, November)"}
                ],
                // selectedFreight: this.$parent.selectedFreight,
                // selectedPeriod: this.$parent.selectedPeriod,
                logistics: this.$parent.logistics,
                countries: countries,
                years: this.$parent.years
            }
        },
        methods: {
            setFreight(freight) {
                this.logistics.freight = freight.value;
            },
            setStorage(event) {
                this.logistics.storage = event.target.value;
            },
            setYear(year) {
                this.logistics.year = year;
            },
            setPeriod(period) {
                this.logistics.period = period.name;
            },
            setAddressType(event) {
                this.logistics.location.type = event.target.value;
            },
            setCountry() {
                this.logistics.location.address.country      = this.selectedCountry.name;
                this.logistics.location.address.country_code = this.selectedCountry.code;
            },
            async validate() {
                this.submitted = true;
                let valid      = await this.$validator.validate();
                return valid;
            }
        }
    }
</script>

<style scoped>
    .invalid-feedback {
        display: block;
    }
</style>
